<!-- LOADING -->
<lib-ags-loading *ngIf="!listApprenant"></lib-ags-loading>

<!-- MAIN CONTENT -->
<div class="synthese-contain" *ngIf="listApprenant">
  <div class="uk-card uk-card-default uk-margin-large-right uk-margin-medium-bottom">
    <div class="uk-card-header uk-padding-small uk-background-muted">
      <div class="uk-width-expand">
        <h3 class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted">
          Apprenant(s)
        </h3>
      </div>
    </div>
    <div class="uk-card-body uk-padding-remove">
      <kendo-panelbar [expandMode]="expandMode" (stateChange)="onPanelChange($event)">
        <kendo-panelbar-item
          *ngFor="let apprenant of listApprenant"
          title="{{ apprenant.nom | uppercase }} {{ apprenant.prenom | titlecase }}"
          [id]="apprenant.id_apprenant"
        >
          <ng-template kendoPanelBarContent>
            <div class="uk-card uk-card-default">
              <div class="uk-card-header uk-padding-small uk-background-muted">
                <div class="uk-width-expand">
                  <h3 class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted">
                    Prérequis
                  </h3>
                </div>
              </div>
              <div class="uk-card-body uk-padding-remove">
                <lib-ags-loading *ngIf="loadingPrerequis"></lib-ags-loading>
                <table class="uk-table uk-table-small uk-table-divider" *ngIf="!loadingPrerequis">
                  <thead>
                    <tr>
                      <th>{{ 'libellé' | uppercase }}</th>
                      <th>{{ 'Description' | uppercase }}</th>
                      <th>{{ 'Date de début' | uppercase }}</th>
                      <th>{{ 'Date de fin' | uppercase }}</th>
                      <th>{{ 'Status' | uppercase }}</th>
                      <th width="10%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let prerequis of listPrerequis">
                      <td>{{ prerequis.libelle }}</td>
                      <td>{{ prerequis.description }}</td>
                      <td>{{ prerequis.date_debut | date: 'dd/MM/yyyy' }}</td>
                      <td>{{ prerequis.date_fin | date: 'dd/MM/yyyy' }}</td>
                      <td class="listOfButton">
                        <div *ngIf="this.getStatut('statut', prerequis.id_justificatif_statut)">
                          <button
                            [togglable]="true"
                            [ngClass]="getStatut('color', prerequis.id_justificatif_statut)"
                            kendoButton
                            class="k-text-uppercase filterButton"
                          >
                            {{ getStatut('libelle', prerequis.id_justificatif_statut) | uppercase }}
                          </button>
                        </div>
                      </td>
                      <td>
                        <button kendoButton
                          class="k-button k-primary"
                          (click)="openPrerequisPopup(prerequis, apprenant)"
                          [svgIcon] ="svgPencil"
                        >
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-template>
        </kendo-panelbar-item>
      </kendo-panelbar>
    </div>
  </div>
</div>

<!-- POP-UP APP JUST -->
<kendo-dialog
  title="{{ dialogTitle }}"
  *ngIf="dialogOpened && dialogData"
  (close)="closeDialog('cancel')"
  [width]="1200"
>
  <div class="uk-container uk-container-expand">
    <div class="uk-flex">
      <div class="uk-width-1-2">
        <div class="uk-grid uk-grid-small">
          <div class="uk-width-1-1">
            <label>Statut</label>
          </div>
          <div class="uk-width-1-1">
            <div class="uk-grid-small">
              <div class="listOfButton" *ngFor="let status of statut_session">
                <button
                  (click)="selectStatut(status.id)"
                  [togglable]="true"
                  [ngClass]="getColor(status)"
                  kendoButton
                  class="k-text-uppercase filterButton"
                >
                  {{ status.libelle | uppercase }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="uk-grid uk-grid-small">
          <div class="uk-width-1-2">
            <label>Date de début</label>
            <div>
              <kendo-datepicker
                [format]="'dd/MM/yyyy'"
                [(ngModel)]="dialogData.date_debut"
                class="dateAppJust"
                (valueChange)="dateDebutChange($event)"
              ></kendo-datepicker>
            </div>
          </div>
          <div class="uk-width-1-2">
            <label>Date de fin</label>
            <div>
              <kendo-datepicker
                [format]="'dd/MM/yyyy'"
                [(ngModel)]="dialogData.date_fin"
                class="dateAppJust"
              ></kendo-datepicker>
            </div>
          </div>
        </div>
        <div class="uk-grid uk-grid-small">
          <div class="uk-width-1-1">
            <p style="font-size: 16px">Durée de {{ dialogData.duree_justificatif || '0' }} mois par défaut</p>
          </div>
        </div>
      </div>
    </div>
  </div>
    <kendo-dialog-actions>
      <button 
      class="k-primary k-button" 
      kendoButton
      (click)="closeDialog('save', dialogData)"
      >
      VALIDER</button>
    </kendo-dialog-actions>
</kendo-dialog>
